import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NbDialogService, NbPopoverDirective } from '@nebular/theme';
import {
  UiAccountsControllerService,
  UiStackControllerService,
} from 'src/app/cc-api/services';
import {
  cloudAccountIcons,
  vcsAccountIcons,
} from '../create-vcs-account-integration/accounts-constants';

@Component({
  selector: 'app-account-selection-dropdown',
  templateUrl: './account-selection-dropdown.component.html',
  styleUrls: ['./account-selection-dropdown.component.scss'],
})
export class AccountSelectionDropdownComponent implements OnInit, OnChanges {
  @Input() selected: any;
  @Output() afterAccountSave: EventEmitter<any> = new EventEmitter<any>();
  @Input() accountType: 'VERSION_CONTROL' | 'CLOUD' | 'CODER';
  @Input() customFormControl: UntypedFormControl;
  @Input() cloudFilter: 'aws' | 'azure' | 'gcp' | 'kubernetes' | 'all';
  @Input() disabled: boolean = false;
  @Input() customPlaceholder: String = '';
  loadingAccounts: boolean = false;
  accounts;
  accountsOptions = [];
  vcsProvidersList = ['GITHUB', 'GITLAB', 'BITBUCKET'];
  accountToBeOpened;
  authMethod = 'CURL';
  currentHoveredBtn;
  vcsAccountIcons = vcsAccountIcons;
  cloudAccountIcons = cloudAccountIcons;
  accountLinkingMode: 'PAT' | 'APP' = 'APP';

  @ViewChild('userAccountPopover', { static: true })
  private userAccountPopover: TemplateRef<any>;
  @ViewChild('vcsAccountIntegrationCreate', { static: true })
  private vcsAccountIntegrationCreate: TemplateRef<any>;
  @ViewChild('cloudAccountCreate', { static: true })
  private cloudAccountCreate: TemplateRef<any>;
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

  constructor(
    private accountControllerService: UiAccountsControllerService,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit(): void {
    this.getAccountDetails();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.cloudFilter?.currentValue != changes?.cloudFilter?.previousValue
    ) {
      if (changes?.cloudFilter?.previousValue?.length) {
        this.customFormControl.reset();
      }
      this.getAccountDetails();
    }
    if (this.customPlaceholder) {
      let accountName = this.accountsOptions?.find(
        (data) => data?.value === this.customPlaceholder,
      )?.label;
      this.customPlaceholder = accountName
        ? accountName
        : this.customPlaceholder;
    }
  }

  getAccountDetails() {
    if (this.accountType === 'CLOUD' && !this.cloudFilter?.length) {
      return;
    }
    this.loadingAccounts = true;
    return new Promise((resolve, reject) => {
      this.accountControllerService
        .getAccountsByTypeUsingGET(this.accountType)
        .subscribe(
          (response) => {
            this.accounts = response;
            if (
              this.accountType === 'CLOUD' &&
              this.cloudFilter &&
              this.cloudFilter != 'all'
            ) {
              this.accounts = this.accounts?.filter(
                (account) =>
                  account?.provider?.toLowerCase() ===
                  this.cloudFilter?.toLowerCase(),
              );
            }
            this.accountsOptions = this.accounts
              .filter((account) => account?.id?.length)
              .map((account) => ({
                label: account.name,
                value: account.id,
                provider: account.provider,
              }));
            this.loadingAccounts = false;
            if (this.selected) {
              const selectedOption = this.accountsOptions.filter(
                (account) => account.value === this.selected,
              );
              setTimeout(() => {
                this.customFormControl.setValue(selectedOption[0]?.value || '');
              }, 30);
            }
            resolve(true);
          },
          (error) => {
            this.loadingAccounts = false;
            resolve(false);
          },
        );
    });
  }

  async openAccDetailsPopover(event, value) {
    event.stopPropagation();
    try {
      this.accountToBeOpened = this.accounts.find(
        (account) => account?.id === value,
      );
      this.dialogService.open(this.userAccountPopover, {
        context: this.accountToBeOpened,
      });
    } catch (error) {}
  }

  onClickCreateNewOption(event) {
    event?.stopPropagation();
    this.customFormControl.setValue('');
  }

  openNewAccountDialog(event) {
    event?.stopPropagation();
    this.dialogService
      .open(this.cloudAccountCreate)
      .onClose.subscribe((data) => {
        this.authMethod = 'CURL';
      });
  }

  onProviderSelection(provider, ref) {
    this.accountLinkingMode = 'APP';
    this.popover.hide();
    this.customFormControl.setValue('');
    this.dialogService.open(this.vcsAccountIntegrationCreate, {
      context: {
        mode: 'create',
        vcsProvider: provider,
        accountType: 'VCS',
      },
      closeOnBackdropClick: false,
    });
  }

  async onAccountsUpdate(account) {
    await this.getAccountDetails();
    this.afterAccountSave.emit(this.accounts);
    setTimeout(() => {
      this.customFormControl.setValue(account?.id);
    }, 300);
  }

  async onCloudAccountsUpdateNewFlow(accountName) {
    await this.getAccountDetails();
    let selectedAcc = this.accounts?.find((acc) => acc?.name === accountName);
    setTimeout(() => {
      this.customFormControl.setValue(selectedAcc?.id);
    }, 300);
  }

  onModeChange(authMethod: 'CURL' | 'CREDS' = 'CREDS') {
    this.authMethod = authMethod;
  }

  changeIntegrationMode(mode) {
    this.accountLinkingMode = mode;
  }
}
